import {_get, _put, clubId} from "@api/doinsport/services/httpService";

const URL = 'news';

export const getActualities= () => _get(URL + '?page=1&itemsPerPage=120');
